import { render, staticRenderFns } from "./relative-contract.vue?vue&type=template&id=3e96f9f3&scoped=true&"
import script from "./relative-contract.vue?vue&type=script&lang=js&"
export * from "./relative-contract.vue?vue&type=script&lang=js&"
import style0 from "./relative-contract.vue?vue&type=style&index=0&id=3e96f9f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e96f9f3",
  null
  
)

export default component.exports